import { FeatureFlagsConfigSchema } from 'config-types/config/feature-flags';

const FEATURE_FLAGS_DATA = {
  labOrdersEnabled: true,
  inHouseLabsEnabled: true,
  radiologyEnabled: true,
  nursingOrdersEnabled: true,
  supervisorApprovalEnabled: true,
  demoVisitsEnabled: false,
  easyChartEnabled: true,
  globalTemplatesEnabled: true,
  legacyDataEnabled: true,
  mailingPaperStatementsEnabled: false,
  legacyPatientFollowupsEnabled: false,
  skipSendingVisitNoteToPatientPortalEnabled: true,
  sendgridEnabled: true,
  automatedPatientOutreachEnabled: true,
  employeeChatEnabled: true,
  ottehrBillingInvoicingEnabled: true,
  customOrganizationsEnabled: true,
};

export const FEATURE_FLAGS_CONFIG = Object.freeze(FeatureFlagsConfigSchema.parse(FEATURE_FLAGS_DATA));
